import { keepPreviousData, QueryCache, QueryClient, QueryClientConfig } from '@tanstack/react-query';
import _ from 'lodash';

import { isSSR } from './helpers';

declare global {
    interface Window {
        ReactQueryCache?: QueryCache;
    }
}

const defaultConfig: QueryClientConfig = {
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            placeholderData: keepPreviousData,
        },
    },
};

/**
 * ⚠️ NOTE: do not use this with react-query `persistQueryClient` as it will cause all clients to be shared and persisted
 */
export const createQueryClient = (customConfig?: QueryClientConfig | null) => {
    let mergedConfig: QueryClientConfig;

    if (process.env.IS_NEXT !== 'true' || !isSSR()) {
        const queryCache = window.ReactQueryCache || new QueryCache();
        window.ReactQueryCache = queryCache;
        mergedConfig = _.merge(defaultConfig, { queryCache }, customConfig);
    } else {
        mergedConfig = _.merge(defaultConfig, customConfig);
    }

    return new QueryClient(mergedConfig);
};
